import React from 'react';
import SiteFooter from './SiteFooter';
import SiteHeader from './SiteHeader';
import {ContactProvider} from './ContactModal';
import {WaitlistProvider} from './WaitlistModal';

interface PublicSiteLayoutProps {
    children: React.ReactNode;
}

const PublicSiteLayout: React.FC<PublicSiteLayoutProps> = ({children}) => {
    return (
        <WaitlistProvider>
            <ContactProvider>
                <div className="site-page-shell">
                    <SiteHeader/>
                    <main className="site-page-content">
                        {children}
                    </main>
                    <SiteFooter/>
                </div>
            </ContactProvider>
        </WaitlistProvider>
    );
};

export default PublicSiteLayout;
